const logotext = "HATIM";
const meta = {
    title: "Hatim | Portfolio",
    description: "I’m Hatim Eddinani Content creator, Full stack developer working remotely",
};

const introdata = {
    title: "I’m Hatim E"
,    animated: {
        first: "I'm a fullstack developer",
        second: "I'm a web 3.0 enthusiast",
        third: "I adore the Backend",
    },
    description: "As a full-stack engineer, I have a passion for building scalable and intuitive web applications. With a strong foundation in ReactJS, Ruby on Rails, and testing libraries like RSpec, Jest, and Capybara, I have the skills to bring projects from conception to deployment.",
    my_img_url: "https://i.ibb.co/M2wz6FC/hatim33.png",
};

const dataabout = {
    title: "A bit about myself",
    aboutme: "Hey, I am Hatim aka theBwoyProgrammer. I'm your friendly neighborhood code wizard! I'm your go-to guru for all things tech. From mastering the art of working with cutting-edge technology to whipping up user-friendly digital delights, I've got you covered. Oh, and did I mention that coding and music are my dynamic duo? Seriously, give me a good beat, and I can code like there's no tomorrow! When I'm not turning caffeine into code, you can catch me exploring new tech frontiers or indulging my creative side with offbeat personal projects. And here's a little tidbit about me: I work in dark mode not to attract bugs. Let's conquer the digital realm together, one line of code at a time.",
};
const worktimeline = [{
        jobtitle: "Full-stack Web developer(Part-time)",
        where: "OvrtiLabs",
        date: "2024",
    },
    {
        jobtitle: "Web Engineer(Contractor/Part-time)",
        where: "Vyudu, Inc",
        date: "2023",
    },
    {
        jobtitle: "Fullstack Web developer(Apprenticeship)",
        where: "Juubix",
        date: "2023",
    },
    {
        jobtitle: "Mentor(Volunteer)",
        where: "Microverse, Inc",
        date: "2022",
    },
];

const skills = [{
        name: "JavaScript",
        value: 70,
    },
    {
        name: "ReactJS",
        value: 75,
    },
    {
        name: "Ruby",
        value: 75,
    },
    {
        name: "Ruby on Rails",
        value: 80,
    },
    {
        name: "Jquery",
        value: 55,
    },
    {
        name: "PHP",
        value: 85,
    },
    {
        name: "Laravel",
        value: 55,
    },
];

const services = [{
        title: "Front-end and Design",
        description: "Build client-side applications with modern features like SPA and maintain semantic coding style among other best practices for SEO optimization. Use modern techs such as ReactJS, TailwindCSS, Bootstrap, and Sass.",
    },
    {
        title: "Backend and Databases + APIs",
        description: "Build scalable and maintainable server applications and APIs using modern technology stacks such as Ruby on Rails, and PostgreSQL.",
    },
    {
        title: "Testing and Deployment",
        description: "Test both frontend and backend web apps with Jest for ReactJS frontend and RSpec + Capybara for Ruby on Rails backend..",
    },
];

const dataportfolio = [{
        img: "https://i.pinimg.com/originals/14/62/5f/14625f7ff33ec31923fc42866d426d2b.jpg",
        desctiption: "In this project, I collaborate with a Dominican Republican developer to develop a freelance agency's website(OvrtiLabs).",
        link: "https://ovrtilabs1-git-main-hatimdev-he.vercel.app/",
        source: "https://github.com/theBwoyProgrammer/ovrtilabs1"
    },
    {
        img: "https://images.pexels.com/photos/14852071/pexels-photo-14852071.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        desctiption: "Space Travel's Hub is a space travel app. It allows the user to reserve(POST) a rocket and a mission and cancel(DELETE) both at any moment from the API. This application was created using ReactJS/Redux and RESTful API.",
        link: "https://space-x-olive.vercel.app/",
        source: "https://github.com/theBwoyProgrammer/Space-X"
    },
    {
        img: "https://i.ibb.co/3m7mCZ8/Fire-Shot-Capture-008-TV-shows-eyasuteshome-github-io.png",
        desctiption: "This website presents the best Tv shows. We used TVmaze API to get the movie content. we have used Javascript, HTML and CSS to build the website.",
        link: "https://eyasuteshome.github.io/MovieArena/",
        source: "https://github.com/theBwoyProgrammer/MovieArena"
    },
    {
        img: "https://i.ibb.co/MhCcvR8/Fire-Shot-Capture-004-TB4-L-Concert-thebwoyprogrammer-github-io.png",
        desctiption: "This is a static app designed for a fictional concert. This website was built with HTML/CSS and JavaScript",
        link: "https://thebwoyprogrammer.github.io/TB4L-Concert/",
        source: "https://github.com/theBwoyProgrammer/TB4L-Concert"
    },
    {
        img: "https://i.pinimg.com/originals/1e/bb/f5/1ebbf5b5c6c00557e2cb1514365cc02a.jpg",
        desctiption: "Coming Soon -- JUUBIX is a Fintech distributed multi-cloud based omni-channel for goods and services  offering a SaaS AI matching tool for startups, expertise and finance.",
        link: "https://www.juubix.co.uk/",
    },
    {
        img: "https://picsum.photos/400/300/?grayscale",
        desctiption: "Project coming soon",
        link: "#",
    },
    {
        img: "https://picsum.photos/400/?grayscale",
        desctiption: "Project coming soon",
        link: "#",
    },
    {
        img: "https://picsum.photos/400/550/?grayscale",
        desctiption: "Project coming soon",
        link: "#",
    },
    {
        img: "https://picsum.photos/400/?grayscale",
        desctiption: "Project coming soon",
        link: "#",
    },
    {
        img: "https://picsum.photos/400/700/?grayscale",
        desctiption: "Project coming soon",
        link: "#",
    },
];

const contactConfig = {
    YOUR_EMAIL: "hatimeddinani@gmail.com",
    YOUR_FONE: "(256)726-582915",
    description: "Do you need assistance with an amazing project? or would you want to add me to your team? Send me a direct message or contact me via instant messenger right away!",
    YOUR_SERVICE_ID: "service_qdczscj",
    YOUR_TEMPLATE_ID: "contact_form",
    YOUR_USER_ID: "2y4Z6NV0rG7o7vMi0",
};

const socialprofils = {
    github: "https://github.com/theBwoyProgrammer",
    Instagram: "https://www.instagram.com/the_bwoy_programmer/",
    linkedin: "https://www.linkedin.com/in/hatimdev/",
    twitter: "https://twitter.com/the_BwoyPrgrmmr",
    wellfound: "https://angel.co/u/hatim-eddinani",
    medium: "https://medium.com/@theBwoyPrgrmmr",
};
export {
    meta,
    dataabout,
    dataportfolio,
    worktimeline,
    skills,
    services,
    introdata,
    contactConfig,
    socialprofils,
    logotext,
};
